import { Field } from "formik";
import { UseUniqueIdReturnType } from "shared/uniqueId/useUniqueId";
import { useTranslation } from "shared/i18n/useTranslation";
import { SurveyFormContainer } from "./SurveyFormContainer";

export function AddressSection({ uid }: { uid: UseUniqueIdReturnType["uid"] }) {
  const { translate } = useTranslation();
  return (
    <div className="mb-3">
      <p>{translate("__siteLocation")}</p>
      <SurveyFormContainer className="p-2">
        <div className="mb-3">
          <label htmlFor={uid("address")} className="form-label">
            {translate("__streetAddress")}
          </label>
          <Field className="form-control" id={uid("address")} name="address" />
        </div>

        <div className="mb-3">
          <label htmlFor={uid("city")} className="form-label">
            {translate("__city")}
          </label>
          <Field className="form-control" id={uid("city")} name="city" />
        </div>

        <div className="row">
          <div className="col-md-6">
            <label htmlFor={uid("state")} className="form-label">
              {translate("__state")}
            </label>
            <Field className="form-control" id={uid("state")} name="state" />
          </div>
          <div className="col-md-6">
            <label htmlFor={uid("zip")} className="form-label">
              {translate("__zipCode")}
            </label>
            <Field className="form-control" id={uid("zip")} name="zip" />
          </div>
        </div>
      </SurveyFormContainer>
    </div>
  );
}
